import Toast from 'emerald-ui/lib/Toast';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Toast, componentName: 'Toast' }], 'Toast'),
  description: 'A Toast shows a notification and an action to perform along with it.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Toast },
      code: `<Toast
  message="This is the message"
  actionText="Undo"
  position="right"
  onActionClick={() => true}
  visible={true}
/>`,
    },
  ],
};
